import { useState, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import AnimatedYPage from './AnimatedYPage';
import { BiHide } from "react-icons/bi";
import { BiShowAlt } from "react-icons/bi";
import Button from '@mui/material/Button';
import { FcGoogle } from "react-icons/fc";
import { useAppContext } from '../services/utils';

function SignUp() {
	const { branches, handleInputChange, registerUser, scrollToTop } = useAppContext();
	let [showPassword, setShowPassword] = useState(false);
	let [showPassword2, setShowPassword2] = useState(false);
	let password_input = useRef();
	let password_input2 = useRef();

	// SHOW/HIDE PASSWORD
	function toggle_show_password(){
		setShowPassword(current => !current);
		if (!showPassword) {
			password_input.current.type = 'text';
		}
		else{
			password_input.current.type = 'password';
		};
	}

	function toggle_show_password2(){
		setShowPassword2(current => !current);
		if (!showPassword2) {
			password_input2.current.type = 'text';
		}
		else{
			password_input2.current.type = 'password';
		};
	}

	const handleSubmit = (e) => {
    e.preventDefault();
		e.target.reset();
		registerUser();
  };

	return (
		<AnimatedYPage>
			<div className=''>
				<div className='h-screen'>
					<div className='text-center'>
						<h2 className='text-green-500 text-2xl mb-4'>Let's get you started</h2>
					</div>
					<form onSubmit={handleSubmit} className='w-full flex flex-column justify-center align-center items-center'>
						<div className='w-10/12 md:w-1/2 mb-2 grid grid-cols-1 md:grid-cols-2 gap-2'>
							<div className="form-floating">
								<input type="text" className="form-control" id="first_name" placeholder="Enter first name" name="first_name" onChange={handleInputChange} required></input>
								<label htmlFor="username">First Name *</label>
							</div>

							<div className="form-floating">
								<input type="text" className="form-control" id="last_name" placeholder="Enter last name" name="last_name" onChange={handleInputChange} required></input>
								<label htmlFor="username">Last Name *</label>
							</div>
						</div>

						<div className="form-floating mb-3 mt-2 w-10/12 md:w-1/2">
							<input type="text" className="form-control" id="email" placeholder="Enter email" name="email" onChange={handleInputChange} required></input>
							<label htmlFor="email">Email *</label>
						</div>

						<div className="form-floating mb-2 mt-1 w-10/12 md:w-1/2 relative">
							<input type="password" ref={password_input} className="form-control password_input" id="password1" placeholder="Enter password" name="password" onChange={handleInputChange} required></input>
							<label htmlFor="password1">Password *</label>
							{showPassword ? <BiShowAlt className='cursor-pointer text-green-500 absolute top-1/3 right-2' size={30} onClick={toggle_show_password} /> : <BiHide className='cursor-pointer text-green-500 absolute top-1/3 right-2' size={30} onClick={toggle_show_password} />}
						</div>

						<div className="form-floating mb-3 mt-2 w-10/12 md:w-1/2">
							<input type="password" ref={password_input2} className="form-control password_input" id="password2" placeholder="Enter password" name="password" onChange={handleInputChange} required></input>
							<label htmlFor="password2">Confirm Password *</label>
							{showPassword2 ? <BiShowAlt className='cursor-pointer text-green-500 absolute top-1/3 right-2' size={30} onClick={toggle_show_password2} /> : <BiHide className='cursor-pointer text-green-500 absolute top-1/3 right-2' size={30} onClick={toggle_show_password2} />}
						</div>

						<input 
							type="submit" 
							className='h-10 mt-3 w-3/4 md:w-1/3 bg-green-400 text-white text-lg font-bold rounded'
							value={"Register"}>
						</input>

						<p className='text-center text-white'>OR</p>
						<div className='mt-1 flex justify-center items-center'>
							<section className='px-2 bg-white flex justify-center items-center text-center border rounded-lg'>
								<FcGoogle size={30}/>
								<Button>Continue with Google</Button>
							</section>
						</div>

						<p className='text-white mt-2 mb-3 text-lg'>Already have an account ? <span className='text-green-500'><NavLink to={'/signin'} className='ml-1' onClick={scrollToTop}>Log In</NavLink></span> </p>
					</form>
				</div>
			</div>
		</AnimatedYPage>
	)
}

export default SignUp;